import { initLottie } from "../modules/lottie.js";
jQuery(($) => initLottie($));
